/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import LabelledField from "components/labelled-field";
import { useTranslation } from "react-i18next";
import { ComponentImageListEditWrapper } from "./component-image-list-wrapper";
import { ImageListItemEditor } from "./list-item";

// Sample: https://www.dnv.org/community-environment/climate-action-and-environment/key-directions

const ImageListComponentEditor = () => {

    const { t } = useTranslation();
    const { component, update, updateFactory } = useUpdateComponent();

    const {
        title,
        description,
        image_list: imageList,
    } = component;

    const onChangeTitle = (event) => {
        const title = event.target.value;
        update("title", title);
    };

    const onChangeDescription = updateFactory("description");
    const onChangeImageList = updateFactory("image_list");

    return (
        <div className='simplicity-editor-frame'>
            <LabelledField label={t("commons.title")}>
                <TextField
                    id='image_list_title'
                    fullWidth={true}
                    value={title}
                    onChange={onChangeTitle}
                />
            </LabelledField>
            <LabelledField label={t("commons.description")}>
                <SimplicityComposerEnsureTipTap
                    richtext={description}
                    onChange={onChangeDescription}
                />
            </LabelledField>
            <ComponentImageListEditWrapper
                list={imageList}
                onChange={onChangeImageList}
            >
                <ImageListItemEditor/>
            </ComponentImageListEditWrapper>

            {/*{Config.Debug.useDebug && (*/}
            {/*    <div>*/}
            {/*        <details>*/}
            {/*            <summary>LocalState</summary>*/}
            {/*            <pre style={{fontSize: '9px', width: '800px', overflowX: 'auto', backgroundColor: '#efefef'}}>*/}
            {/*                    {JSON.stringify(localState, null, 2)}*/}
            {/*                </pre>*/}
            {/*        </details>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    );
};
ImageListComponentEditor.displayName = "ImageListComponentEditor";
export { ImageListComponentEditor };
